import PropTypes from 'prop-types';
import React from 'react'
const WEEKDAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

const Header = ({ label, date }) => {
	let weekdayClass = 'rbc-weekday-' + WEEKDAYS[date.getDay()];
  return <span className={weekdayClass}>{label}</span>
}

Header.propTypes = {
  label: PropTypes.node,
}

export default Header



// WEBPACK FOOTER //
// ./src/vendor/react-big-calendar/Header.js